import { useState, useEffect } from 'react';
import { contractService } from '../services/contractService';
import type { Contract } from '@shared/types';

export function useContracts() {
  const [contracts, setContracts] = useState<Contract[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadContracts = async () => {
    try {
      setLoading(true);
      const data = await contractService.getContracts();
      setContracts(data);
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load contracts');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadContracts();
  }, []);

  return {
    contracts,
    loading,
    error,
    reload: loadContracts,
  };
}

export function useContract(id: string) {
  const [contract, setContract] = useState<Contract | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadContract = async () => {
    try {
      setLoading(true);
      const data = await contractService.getContract(id);
      setContract(data);
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load contract');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      loadContract();
    }
  }, [id]);

  return {
    contract,
    loading,
    error,
    reload: loadContract,
  };
}

